import { downloadAsCsvFileWithHeaders } from 'utils/csv';

export const COOKIE_NAMES = ['XSRF-TOKEN'];

export const getCookie = (name) => {
  const cookieExists = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return cookieExists ? cookieExists[2] : undefined;
};

export const getListOfNecessaryCookies = () =>
  COOKIE_NAMES.map((name) => ({
    key: name,
    value: getCookie(name),
  }));

export const adminEndpointsFormStateReducer = (state, action) => {
  const { name, type, value } = action;
  switch (type) {
    case 'checkbox':
      return { ...state, [name]: !state[name] };
    default:
      return { ...state, [name]: value };
  }
};

/** Download response in CSV format from route: /admin/journeyChecker */
export const formatJourneyCheckerResponse = (downloadResponse) => {
  const [headerRow, ...rows] = downloadResponse.split('\n');
  const headers = headerRow.split(',');
  const data = rows.map((row) => row.split(','));

  downloadAsCsvFileWithHeaders({
    data,
    fileName: `journeyChecker-${Date.now()}`,
    headers,
  });
};
